import { render, staticRenderFns } from "./DetailRewardPrivilege.vue?vue&type=template&id=546d2dc4&scoped=true"
import script from "./DetailRewardPrivilege.vue?vue&type=script&lang=js"
export * from "./DetailRewardPrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d2dc4",
  null
  
)

export default component.exports